(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1643],{

/***/ 15010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Seo_SeoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(40686);
;// CONCATENATED MODULE: ./src/components/Seo/SeoContent.tsx

var SeoContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "seo-content prose prose-slate relative mx-auto w-full max-w-none",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var Seo_SeoContent = (SeoContent);

;// CONCATENATED MODULE: ./src/components/Seo/SeoWrapper.tsx







var SeoWrapper = function(param) {
    var children = param.children, helmetSettings = param.helmetSettings, content = param.content;
    var title = helmetSettings.title, script = helmetSettings.script, restHelmetSettings = (0,_object_without_properties/* default */.Z)(helmetSettings, [
        "title",
        "script"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, (0,_object_spread/* default */.Z)({}, restHelmetSettings)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            script ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: script
                }
            }) : null,
            children,
            content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo_SeoContent, {
                content: content
            }) : null
        ]
    });
};
/* harmony default export */ var Seo_SeoWrapper = (SeoWrapper);


/***/ }),

/***/ 95614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(18098);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(28525);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24800);
/* harmony import */ var components_common_BImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69327);
/* harmony import */ var components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95269);
/* harmony import */ var enums_businessModel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60287);
/* harmony import */ var enums_currency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85032);
/* harmony import */ var enums_vehiclePriceUnit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82871);
/* harmony import */ var hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43617);
/* harmony import */ var hooks_useFavorite__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61356);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32466);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40515);
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49163);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41824);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80810);
/* harmony import */ var styles_VehicleCard_module_css__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(61234);
/* harmony import */ var styles_VehicleCard_module_css__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(styles_VehicleCard_module_css__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10520);
/* harmony import */ var utils_vehicleNameCreator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45581);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(58382);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var hooks_useSearchFromQuery__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(12217);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(13253);
/* harmony import */ var components_common_Favourited__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(76417);
/* harmony import */ var components_common_RatingStar__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(31399);
































var VehicleCard = function(_param) {
    var containerClass = _param.containerClass, _isFirstImagePrioritized = _param.isFirstImagePrioritized, isFirstImagePrioritized = _isFirstImagePrioritized === void 0 ? false : _isFirstImagePrioritized, location = _param.location, vehicle = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_param, [
        "containerClass",
        "isFirstImagePrioritized",
        "location"
    ]);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("common").t;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var isMobile = (0,hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_8__/* .useBreakpoint */ .G)().isMobile;
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_24__/* .useUserState */ .e)().isUserLoggedIn;
    var getVehicleFavorited = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_17__/* .useFavoriteStore */ .E)().getVehicleFavorited;
    var ref1 = (0,hooks_useSearchFromQuery__WEBPACK_IMPORTED_MODULE_23__/* .useSearchFromQuery */ .o)(), getStateFromQuery = ref1.getStateFromQuery, getLocationFromRoute = ref1.getLocationFromRoute;
    var ref2, ref3;
    var analyticsPayload = (0,react__WEBPACK_IMPORTED_MODULE_13__.useMemo)(function() {
        var ref, ref1, ref4;
        return {
            asPath: asPath,
            vehiclePriceUnit: ((ref = vehicle.price) === null || ref === void 0 ? void 0 : ref.unit) || enums_vehiclePriceUnit__WEBPACK_IMPORTED_MODULE_7__/* .VehiclePriceUnit.HOUR */ .k.HOUR,
            currency: (ref2 = (ref1 = vehicle.price) === null || ref1 === void 0 ? void 0 : ref1.currency) !== null && ref2 !== void 0 ? ref2 : enums_currency__WEBPACK_IMPORTED_MODULE_6__/* .Currency.TRY */ .F.TRY,
            hourlyPrice: (ref3 = (ref4 = vehicle.price) === null || ref4 === void 0 ? void 0 : ref4.amount) !== null && ref3 !== void 0 ? ref3 : 0,
            region: vehicle.regionTR,
            vehicleType: vehicle.type,
            vehicleId: vehicle.vehicleId,
            vehicleName: (0,utils_vehicleNameCreator__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(vehicle.brand, vehicle.length, t("boatTypes.".concat(vehicle.type)), t)
        };
    }, [
        asPath,
        t,
        vehicle
    ]);
    var isFavorited = isUserLoggedIn && (vehicle.isFavorited || getVehicleFavorited(vehicle.vehicleId));
    var ref4 = (0,hooks_useFavorite__WEBPACK_IMPORTED_MODULE_9__/* .useFavorite */ .s)(isFavorited, analyticsPayload), isCurrentFavorited = ref4.isCurrentFavorited, toggleFavorite = ref4.toggleFavorite;
    var constructHourlyQueryParams = function(params) {
        var ref;
        return {
            date: params.startTime ? (ref = params.startTime) === null || ref === void 0 ? void 0 : ref.getTime() : undefined,
            duration: params.startTime && params.endTime ? services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.getHourDuration */ .o.getHourDuration(params.startTime, params.endTime) : undefined,
            numberOfPeople: params.numberOfPeople,
            fromLocation: params.fromLocation
        };
    };
    var constructDWQueryParams = function(params) {
        var ref, ref1;
        return {
            startDate: (ref = params.startTime) === null || ref === void 0 ? void 0 : ref.getTime(),
            endDate: (ref1 = params.endTime) === null || ref1 === void 0 ? void 0 : ref1.getTime(),
            numberOfPeople: params.numberOfPeople,
            fromLocation: params.fromLocation
        };
    };
    var contructQueryParams = function() {
        var ref, ref1, ref2;
        var mappedQueries = getStateFromQuery();
        var startTime = undefined;
        var endTime = undefined;
        if ((ref = vehicle.nearestAvailableTime) === null || ref === void 0 ? void 0 : ref.startTime) {
            startTime = services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatServerDateToLocalDate */ .o.formatServerDateToLocalDate(vehicle.nearestAvailableTime.startTime);
        } else if (mappedQueries.startTime) {
            startTime =  true ? services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatUtcDateToLocalTz */ .o.formatUtcDateToLocalTz(mappedQueries.startTime) : 0;
        }
        if ((ref1 = vehicle.nearestAvailableTime) === null || ref1 === void 0 ? void 0 : ref1.endTime) {
            endTime = services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatServerDateToLocalDate */ .o.formatServerDateToLocalDate(vehicle.nearestAvailableTime.endTime);
        } else if (mappedQueries.endTime) {
            endTime =  true ? services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatUtcDateToLocalTz */ .o.formatUtcDateToLocalTz(mappedQueries.endTime) : 0;
        }
        var mappedDto = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, mappedQueries), {
            startTime: startTime,
            endTime: endTime,
            fromLocation: (ref2 = getLocationFromRoute()) === null || ref2 === void 0 ? void 0 : ref2.name
        });
        var mappedSearchState;
        if (vehicle.businessModel === enums_businessModel__WEBPACK_IMPORTED_MODULE_5__/* .BusinessModel.HOURLY */ .v.HOURLY) {
            mappedSearchState = constructHourlyQueryParams(mappedDto);
        } else {
            mappedSearchState = constructDWQueryParams(mappedDto);
        }
        return qs__WEBPACK_IMPORTED_MODULE_30___default().stringify(mappedSearchState);
    };
    var linkConstructor = function() {
        var queryParams = contructQueryParams();
        return services_LinkService__WEBPACK_IMPORTED_MODULE_16__/* .linkService.getVehicleLink */ .k.getVehicleLink(vehicle.type, vehicle.vehicleId, locale, queryParams);
    };
    var sendAnalytics = function() {
        services_AnalyticsService__WEBPACK_IMPORTED_MODULE_14__/* .analyticsService.vehicleCardClick */ .I.vehicleCardClick(analyticsPayload);
    };
    var nearestAvailableTime = (0,react__WEBPACK_IMPORTED_MODULE_13__.useMemo)(function() {
        if (!vehicle.nearestAvailableTime) return null;
        else {
            var startTime = services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatServerDateToLocalDate */ .o.formatServerDateToLocalDate(vehicle.nearestAvailableTime.startTime);
            var endTime = services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.formatServerDateToLocalDate */ .o.formatServerDateToLocalDate(vehicle.nearestAvailableTime.endTime);
            if (vehicle.businessModel === enums_businessModel__WEBPACK_IMPORTED_MODULE_5__/* .BusinessModel.HOURLY */ .v.HOURLY) {
                return services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.getReadableShortRangeDateTime */ .o.getReadableShortRangeDateTime(startTime, startTime.getHours(), endTime.getHours());
            }
            if (vehicle.businessModel === enums_businessModel__WEBPACK_IMPORTED_MODULE_5__/* .BusinessModel.DAILY_WEEKLY */ .v.DAILY_WEEKLY) {
                return services_DateService__WEBPACK_IMPORTED_MODULE_15__/* .dateService.getReadableShortRangeDate */ .o.getReadableShortRangeDate(startTime, endTime);
            }
        }
    }, [
        vehicle.nearestAvailableTime,
        vehicle.businessModel
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("translate-z-0 absolute top-1.5 z-10 flex w-full items-center px-1.5", vehicle.immediatelyReservable ? "justify-between" : "justify-end"),
                children: [
                    vehicle.immediatelyReservable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "shadow-sm shadow-slate-500",
                        variant: "info",
                        contrasted: true,
                        children: t("vehicleImmediatelyReservable")
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "transform cursor-pointer rounded-full duration-200 ease-in",
                        onClick: function() {
                            return toggleFavorite(vehicle.vehicleId);
                        },
                        tabIndex: -1,
                        role: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Favourited__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                            isCurrentFavorited: isCurrentFavorited
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                href: linkConstructor(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_VehicleCard_module_css__WEBPACK_IMPORTED_MODULE_31___default().container), containerClass),
                    target: isMobile ? "" : "_blank",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_VehicleCard_module_css__WEBPACK_IMPORTED_MODULE_31___default().image),
                            onClick: sendAnalytics,
                            role: "presentation",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_21__/* .Swiper */ .tq, {
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_18__/* .Pagination */ .tl
                                ],
                                pagination: {
                                    clickable: true,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 5
                                },
                                spaceBetween: 0,
                                slidesPerView: 1,
                                children: vehicle.images.map(function(image, idx) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_21__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: image,
                                            height: 240,
                                            width: 300,
                                            alt: vehicle.type,
                                            className: "object-cover",
                                            priority: isFirstImagePrioritized && idx === 0
                                        })
                                    }, "".concat(image, "-").concat(idx));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-1 flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-sm",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "text-base font-medium",
                                                children: [
                                                    "".concat(vehicle.originHarbor, ", ").concat(vehicle.region),
                                                    location && location !== vehicle.originHarbor ? " - (".concat(t("departuredFrom", {
                                                        location: location
                                                    }), ")") : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex shrink-0 items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RatingStar__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                commentCount: vehicle.commentCount,
                                                rating: vehicle.rating,
                                                size: 16,
                                                small: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mb-1 block text-sm text-slate-500",
                                    children: t("boatTypes.".concat(vehicle.type))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "mb-2 block text-sm text-slate-500",
                                    children: [
                                        t("capacity"),
                                        ":",
                                        " ",
                                        t("numberOfPeople", {
                                            numberOfPeople: vehicle.fullCapacity
                                        })
                                    ]
                                }),
                                nearestAvailableTime ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mb-2 block text-sm text-slate-500",
                                    children: nearestAvailableTime
                                }) : null,
                                !vehicle.price ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: "text-lg",
                                            price: vehicle.price.amount,
                                            currency: vehicle.price.currency
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-lg text-slate-500",
                                            children: t("businessModelPriceBreakpoints.".concat(vehicle.price.unit))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleCard);


/***/ }),

/***/ 24800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80207);



var BBadge = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, children = param.children, className = param.className, _contrasted = param.contrasted, contrasted = _contrasted === void 0 ? false : _contrasted;
    var classesByVariant = {
        primary: "text-primary-900 bg-primary-100",
        secondary: "text-slate-900 bg-slate-100",
        success: "text-success-900 bg-success-100",
        danger: "text-danger-900 bg-danger-100",
        warning: "text-warning-900 bg-warning-100",
        info: "text-info-900 bg-info-100"
    };
    var contrastedClasses = {
        primary: "bg-primary-600 text-white",
        secondary: "bg-slate-600 text-white",
        success: "bg-success-600 text-white",
        danger: "bg-danger-600 text-white",
        warning: "bg-warning-600 text-white",
        info: "bg-info-600 text-white"
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_1__.cn)("inline-block rounded-full px-3 py-1.5 text-xs md:text-sm", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, classesByVariant[variant], !contrasted), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, contrastedClasses[variant], contrasted), _obj), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBadge);


/***/ }),

/***/ 95269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_CurrencyText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/hooks/useNumberFormat.ts
var useNumberFormat = __webpack_require__(58795);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./src/enums/currency.ts
var currency = __webpack_require__(85032);
// EXTERNAL MODULE: ./src/services/CookieService.ts
var CookieService = __webpack_require__(79925);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(15578);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(52500);
;// CONCATENATED MODULE: ./src/states/useCurrencyState.ts






var useCurrencyState = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set) {
    return {
        currency: CookieService/* cookieService.getCookie */._.getCookie("currency", {}) || currency/* Currency.TRY */.F.TRY,
        setCurrency: function(val) {
            return set(function(state) {
                CookieService/* cookieService.setCookie */._.setCookie("currency", val, {});
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    currency: val
                });
            });
        }
    };
}));

;// CONCATENATED MODULE: ./src/components/common/CurrencyText.tsx





var CurrencyText = /*#__PURE__*/ (0,react.memo)(function CurrencyText(param) {
    var price = param.price, propCurrency = param.currency, className = param.className;
    var ref = useCurrencyState(), stateCurrency = ref.currency;
    var priceFormat = (0,useNumberFormat/* useNumberFormat */.h)().priceFormat;
    var localizedPrice = priceFormat(price, propCurrency !== null && propCurrency !== void 0 ? propCurrency : stateCurrency);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()(className),
        children: localizedPrice
    });
});
/* harmony default export */ var common_CurrencyText = (CurrencyText);


/***/ }),

/***/ 76417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _CdnSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76307);


var Favourited = function(param) {
    var isCurrentFavorited = param.isCurrentFavorited, _size = param.size, size = _size === void 0 ? 32 : _size, _isPrimary = param.isPrimary, isPrimary = _isPrimary === void 0 ? false : _isPrimary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CdnSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        alt: isCurrentFavorited ? "remove favourite" : "favourite",
        className: "max-w-none drop-shadow-md transition-[transform] duration-100 ease-in active:scale-90",
        src: isCurrentFavorited ? "favourite".concat(isPrimary ? "-primary" : "", "-fill.svg") : "favourite".concat(isPrimary ? "-primary" : "", ".svg"),
        size: size
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Favourited);


/***/ }),

/***/ 31399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58795);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80207);
/* harmony import */ var _CdnSvg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76307);





var RatingStar = function(param) {
    var rating = param.rating, commentCount = param.commentCount, _hideCommentCount = param.hideCommentCount, hideCommentCount = _hideCommentCount === void 0 ? false : _hideCommentCount, _size = param.size, size = _size === void 0 ? 24 : _size, _small = param.small, small = _small === void 0 ? false : _small;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var numberLocaleFormat = (0,hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__/* .useNumberFormat */ .h)().numberLocaleFormat;
    var sizeClass = small ? "text-xs" : "text-sm md:text-base";
    var gapClass = small ? "gap-1" : "gap-2";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_3__.cn)("flex items-center", gapClass),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CdnSvg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                src: "star-fill.svg",
                size: size,
                alt: "rating-star"
            }),
            !rating || isNaN(rating) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: sizeClass,
                children: numberLocaleFormat(rating)
            }),
            hideCommentCount ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_3__.cn)("text-slate-500 md:inline", sizeClass),
                children: "(".concat(t("totalCommentCount", {
                    count: commentCount
                }), ")")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingStar);


/***/ }),

/***/ 85032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; }
/* harmony export */ });
var Currency;
(function(Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["TRY"] = "TRY";
})(Currency || (Currency = {}));


/***/ }),

/***/ 63932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useAuthCheck; }
/* harmony export */ });
/* harmony import */ var enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85561);
/* harmony import */ var states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31087);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13253);



function useAuthCheck() {
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_2__/* .useUserState */ .e)().isUserLoggedIn;
    var ref = (0,states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__/* .useAuthModalState */ .d)(), setAuthMode = ref.setAuthMode, setShowAuthModal = ref.setShowAuthModal;
    var checkLoggedIn = function() {
        if (!isUserLoggedIn) {
            setAuthMode(enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__/* .AuthModalMode.LOGIN */ .g.LOGIN);
            setShowAuthModal(true);
        }
        return isUserLoggedIn;
    };
    return {
        checkLoggedIn: checkLoggedIn
    };
}


/***/ }),

/***/ 61356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useFavorite; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50132);
/* harmony import */ var services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32102);
/* harmony import */ var _useAuthCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63932);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80810);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40515);








function useFavorite(isFavorited, analyticsPayload, experienceAnalyticsPayload) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isFavorited), isCurrentFavorited = ref[0], setIsCurrentFavorited = ref[1];
    var checkLoggedIn = (0,_useAuthCheck__WEBPACK_IMPORTED_MODULE_1__/* .useAuthCheck */ .P)().checkLoggedIn;
    var ref1 = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_3__/* .useFavoriteStore */ .E)(), setFavoritedVehicleIds = ref1.setFavoritedVehicleIds, favoritedVehicleIds = ref1.favoritedVehicleIds, setFavoritedExperienceIds = ref1.setFavoritedExperienceIds, favoritedExperienceIds = ref1.favoritedExperienceIds;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsCurrentFavorited(isFavorited);
    }, [
        isFavorited
    ]);
    var toggleFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(vehicleId) {
            var notChangedState, itemIdx, newFavoritedVehicles, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        notChangedState = isCurrentFavorited;
                        if (!notChangedState) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.removeFavorite */ .z.removeFavorite(vehicleId)
                        ];
                    case 2:
                        _state.sent();
                        itemIdx = favoritedVehicleIds.findIndex(function(v) {
                            return v === vehicleId;
                        });
                        if (~itemIdx) {
                            newFavoritedVehicles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedVehicleIds);
                            newFavoritedVehicles.splice(itemIdx, 1);
                            setFavoritedVehicleIds(newFavoritedVehicles);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.addFavorite */ .z.addFavorite(vehicleId)
                        ];
                    case 4:
                        _state.sent();
                        analyticsPayload && services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__/* .analyticsService.addToFavorite */ .I.addToFavorite(analyticsPayload);
                        setFavoritedVehicleIds((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedVehicleIds).concat([
                            vehicleId
                        ]));
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFavorite(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleExperienceFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(vehicleId) {
            var notChangedState, itemIdx, newFavoritedExperiences, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        notChangedState = isCurrentFavorited;
                        if (!notChangedState) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.removeExperienceFavorite */ .z.removeExperienceFavorite(vehicleId)
                        ];
                    case 2:
                        _state.sent();
                        itemIdx = favoritedExperienceIds.findIndex(function(v) {
                            return v === vehicleId;
                        });
                        if (~itemIdx) {
                            newFavoritedExperiences = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedExperienceIds);
                            newFavoritedExperiences.splice(itemIdx, 1);
                            setFavoritedExperienceIds(newFavoritedExperiences);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.addExperienceFavorite */ .z.addExperienceFavorite(vehicleId)
                        ];
                    case 4:
                        _state.sent();
                        experienceAnalyticsPayload && services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__/* .analyticsService.addToFavoriteExperience */ .I.addToFavoriteExperience(experienceAnalyticsPayload);
                        setFavoritedExperienceIds((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedExperienceIds).concat([
                            vehicleId
                        ]));
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleExperienceFavorite(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        toggleFavorite: toggleFavorite,
        toggleExperienceFavorite: toggleExperienceFavorite,
        isCurrentFavorited: isCurrentFavorited
    };
}


/***/ }),

/***/ 58795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useNumberFormat; }
/* harmony export */ });
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74021);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


function useNumberFormat() {
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__/* .useLocale */ .b)().locale;
    var numberLocaleFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(n) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2
        };
        return new Intl.NumberFormat(locale, options).format(n);
    }, [
        locale
    ]);
    var priceFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(price, currency) {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency
        }).format(price);
    }, [
        locale
    ]);
    return {
        numberLocaleFormat: numberLocaleFormat,
        priceFormat: priceFormat
    };
}


/***/ }),

/***/ 61234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleCard_container__goPtV","image":"VehicleCard_image__ON6Qn","dash":"VehicleCard_dash__nVRTt","star":"VehicleCard_star__0vXx8"};

/***/ })

}]);